import { SecondaryWinnersItem } from './components/SecondaryWinnersItem';
import { SECONDARY_WINNER_LIST } from './constants';
import styles from './styles.module.scss';

export const SecondaryWinners = () => (
  <div className={styles.container}>
    {SECONDARY_WINNER_LIST.map((winner) => (
      <SecondaryWinnersItem key={winner.id} {...winner} />
    ))}
  </div>
);
